import React from 'react'
import Loadable from 'Components/LoadableToImported'

import { connect } from 'react-redux'
import { googleAnalyticsEvent } from 'Modules/googleAnalytics/actions'
// import MainAlgoAutoComplete from './MainAlgoAutoComplete'


const loading = () => <div style={{ height: '40px' }} />
export const MainAlgoAutoComplete = Loadable({
  loader: () => import(/* webpackChunkName: "AutoComplete" */ './MainAlgoAutoComplete'),
  loading,
  chunkName: 'MainAlgoAutoComplete',
})

const mapStateToProps = state => ({
  lastPath: state.location.lastPath,
  userCurrentArea: state.userDefaults.userCurrentArea,
  areas: state.areasData.areas,
  result: state.searchAutoComplete.algoResult,
})

const actions = {
  googleAnalyticsEvent,
}

export default connect(mapStateToProps, actions)(MainAlgoAutoComplete)
